import { Reducer } from 'redux';

import { changeUser } from '#/reduxState/currentUser/currentUserReducer';
import { dismissNotice } from '#/reduxState/notices/noticesReducer';

// TODO: remove ?

// import {
//   Chains,
//   chainsMap,
// } from '#/reduxState/exchange/exchangeActiveChainUtils';

// Actions

// export const toggleFavoriteMarket = (chain: Chains, market: string) =>
//   ({
//     type: 'USER_SETTINGS_FAVORITE_MARKET_TOGGLE',
//     payload: {
//       market: `${chainsMap[chain]?.shortCode}:${market}`,
//     },
//   } as const);

export const openSettings = (open = true) =>
  ({
    type: 'USER_SETTINGS_OPEN',
    open,
  }) as const;

type UserSettingsActions = ReturnType<
  // typeof toggleFavoriteMarket
  typeof changeUser | typeof dismissNotice | typeof openSettings
>;

type UserSettingsState = Readonly<{
  settingsOpen: boolean;
  /**
   * Has the user provided gdrpConsent for storing of cookies? The number represents the version they
   * have accepted with 0 meaning they have not accepted anything.
   */
  gdprConsent: number;
  /**
   * The users favorited markets.
   */
  // favoriteMarkets: string[];
  /**
   * An array of ID's of notices that the user has dismissed and should not be displayed (unless that notice is
   * no longer dismissable).
   */
  dismissedNotices: string[];
}>;

export const defaultUserSettingsState: UserSettingsState = {
  settingsOpen: false,
  // Always approved
  gdprConsent: 1,
  // favoriteMarkets: [],
  // Note that other than Ethereum notices will contain chain prefix eg. "bsc:123"
  dismissedNotices: [],
};

// @cached see caching.ts
export const userSettingsReducer: Reducer<
  UserSettingsState,
  UserSettingsActions
> = (state = defaultUserSettingsState, action): UserSettingsState => {
  switch (action.type) {
    // No action on user change - we persist everything in localStorage
    // case 'CHANGE_USER':
    //
    // case 'USER_SETTINGS_FAVORITE_MARKET_TOGGLE': {
    //   const favoriteMarkets = new Set(state.favoriteMarkets || []);
    //   if (!favoriteMarkets.has(action.payload.market)) {
    //     favoriteMarkets.add(action.payload.market);
    //   } else {
    //     favoriteMarkets.delete(action.payload.market);
    //   }
    //   return {
    //     ...state,
    //     favoriteMarkets: Array.from(favoriteMarkets),
    //   };
    // }
    case 'USER_SETTINGS_OPEN':
      return {
        ...state,
        settingsOpen: action.open,
      };
    case 'NOTICES_DISMISS': {
      if (!action.id) {
        console.warn('Trying to dismiss Notice without ID');
        return state;
      }
      const dismissedNotices = new Set(state.dismissedNotices || []);
      if (dismissedNotices.has(action.id)) {
        return state;
      }
      dismissedNotices.add(action.id);
      return {
        ...state,
        dismissedNotices: Array.from(dismissedNotices),
      };
    }
    // case 'USER_SETTINGS_GDRP_CONSENT': {
    //   const { gdprConsent } = action.payload;
    //   if (gdprConsent === state.gdprConsent) {
    //     return state;
    //   }
    //   return { ...state, gdprConsent };
    // }
    default:
      return state;
  }
};
